import React from 'react';
import { useParams, Navigate  } from 'react-router-dom';
import SchoolHeader from './SchoolHeader.jsx';
import SchoolFooter from './SchoolFooter.jsx';
import SchoolStickyFooter from './SchoolStickyFooter.jsx';

function SchoolLayout({ children }) {
  const { school_slug } = useParams();
 
  const validSchools = [
    "alipurduar",
    "bolpur",
    "coochbehar",
    "durgapur",
    "falakata",
    "gangarampur",
    "hooghly",
    "jalpaiguri",
    "kolaghat",
    "krishnanagar",
    "midnapore",
    "nabadwip",
    "raiganj",
    "raniganj",
    "siliguri",
  ];

  // 🔐 Slug validation
  if (!validSchools.includes(school_slug?.toLowerCase())) {
    return <Navigate to="/unauthorized" replace />;
  }
 

  return (
    <>
      <SchoolHeader schoolId={school_slug} />

      

      <main>{children}</main>

      <SchoolStickyFooter />
      <SchoolFooter schoolId={school_slug} />
    </>
  );
}

export default SchoolLayout;
